import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
    const t = localStorage.getItem("vdi_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

export const setToken = (t) => {
    if (t) localStorage.setItem("vdi_token", t);
    else localStorage.removeItem("vdi_token");
};
export const getToken = () => localStorage.getItem("vdi_token");

export const mediaUrl = (relativeOrAbsolute) => {
    if (!relativeOrAbsolute) return null;
    if (relativeOrAbsolute.startsWith("http")) return relativeOrAbsolute;
    return `${BACKEND_URL}${relativeOrAbsolute}`;
};
